import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class JournalsIndexRoute extends Route {
  @service fundsService;
  @service journalService;
  @service navbarSettings;
  @service taskService;

  beforeModel() {
    this.navbarSettings.title = 'Delete Journal';
  }

  async model() {
    await this.fundsService.confirmValidFundToken();
    await this.taskService.load();
    await this.journalService.load();
    let journalId = this.paramsFor('funds.fund.journals.journal').journalId;
    let journalInfo = this.journalService.journalInfoById(journalId);
    return {
      journalInfo,
    };
  }
}
